import { render, staticRenderFns } from "./SettlementsByContract.vue?vue&type=template&id=1efb899a&"
import script from "./SettlementsByContract.vue?vue&type=script&lang=js&"
export * from "./SettlementsByContract.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports